export default __webpack_public_path__ + "static/media/pic.00d92f05.png";